export const TRANSLATIONS_UK = {
  "routes_Pages": "Сторінки",
  "routes_Dashboard": "Інформаційна панель",
  "routes_Questionnaire": "Стандарти",
  "routes_Stats": "Статистика",
  "routes_Settings": "Налаштування",
  "routes_Resouces": "Ресурси",
  "routes_Contact": "Контакти",
  "routes_Downloads": "Завантаження",
  "routes_Documentation": "Документація",
  "dashboard_welcome_message": "Ласкаво просимо до інформаційної панелі системи управління доступом 👋",
  "dashboard_label": "Всі ваші дані про доступність зібрані, структуровані та відстежуються в одному місці.",
  "gettingStartedCard_gettingStarted": "Початок роботи",
  "gettingStartedCard_gettinStartedDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam elementum dui nunc, ac porta sem consequat nec. Pellentesque",
  "gettingStartedCard_Steps": "Ми рекомендуємо почати з цих кроків:",
  "gettingStartedCard_step1": "Прочитайте документацію",
  "gettingStartedCard_step2": "Завантажити контрольний список",
  "gettingStartedCard_step3": "Перевірте свою статистику",
  "companyCard_supportedStandards": "Підтримувані стандарти:",
  "companyCard_companyInformation": "Інформація про компанію",
  "companyCard_numberOfEmployees": "працівники",
  "propertyListPage_propertyList": "Список нерухомості",
  "propertyListPage_dashboard": "Інформаційна панель",
  "propertyListPage_Questionnaire": "Стандарти",
  "propertyListPage_newProperty": "Нова нерухомість",
  "propertyListPage_textmapEdit": "Редагувати нерухомість",
  "propertyListPage_textmapQuestionnaire": "Класифікація",
  "propertyListPage_textmapFacility": "Редагувати споруди",
  "propertyListPage_textmapNewProperty": "Нова нерухомість",
  "propertyListPage_createNewProperty": "Створити нову нерухомість",
  "propertyListPage_disabilityClassification": "Класифікація інвалідності",
  "propertyListPage_editProperty": "Редагувати нерухомість",
  "propertyListPage_editFacilities": "Редагувати споруди",
  "propertyListPage_classify": "Класифікація",
  "propertyListPage_search": "Пошук за назвою об'єкта нерухомості",
  "propertyForm_propertyInformation": "1.1 Інформація про об'єкт нерухомості",
  "propertyForm_standardType": "Тип стандарту",
  "propertyForm_fieldCannotBeChanged": "Це поле не можна змінити",
  "propertyForm_propertyCategory": "Категорія нерухомості",
  "propertyForm_typeOfProperty": "Тип об'єкта нерухомості",
  "propertyForm_propertyName": "Назва об'єкта нерухомості",
  "propertyForm_propertyArea": "Кількість квадратних метрів поверхні підлоги",
  "propertyForm_enterPropertyAddress": "1.1.2 Введіть адресу об'єкта нерухомості",
  "propertyForm_addressLocation": "Введіть місце розташування адреси нижче",
  "propertyForm_mapNote": "Якщо потрібно, ви можете налаштувати карту так, щоб мітка була в потрібному місці",
  "propertyForm_keyPropertyData": "1.2 Основні дані про нерухомість",
  "propertyForm_floorsQuestion": "Скільки поверхів має ваша нерухомість?",
  "propertyForm_roomsQuestion": "Скільки кімнат у вашому помешканні?",
  "propertyForm_disabledRoomsQuestion": "Скільки номерів для людей з обмеженими фізичними можливостями є у вашому готелі?",
  "propertyForm_alergyRoomsQuestion": "Скільки кімнат для алергіків у вашому готелі?",
  "propertyForm_save": "Зберегти",
  "propertyForm_propertyHotelTypeOptionsLabel_Hotel": "Готель",
  "propertyForm_propertyHotelTypeOptionsLabel_Motel": "Мотель",
  "propertyForm_propertyConvenienceStoreOptions_Candies": "Цукерки",
  "propertyForm_propertyConvenienceStoreOptions_Newspapers": "Газети",
  "propertyForm_propertyConvenienceStoreOptions_TobaccoProducts": "Тютюнові вироби",
  "propertyForm_propertyConvenienceStoreOptions_Toiletries": "Туалетні приналежності",
  "propertyForm_propertyConvenienceStoreOptions_Store": "Магазин",
  "propertyForm_propertyConvenienceStoreOptions_Supermarket": "Супермаркет",
  "propertyForm_propertyDepartmentStoreOptions_Clothing": "Одяг",
  "propertyForm_propertyDepartmentStoreOptions_DepartmentStore": "Універмаг",
  "propertyForm_propertyDepartmentStoreOptions_Electronics": "Електроніка",
  "propertyForm_propertyDepartmentStoreOptions_Garden": "Сад",
  "propertyForm_propertyDepartmentStoreOptions_Household_goods": "Господарські товари",
  "propertyForm_propertyDepartmentStoreOptions_Pets": "Домашні тварини",
  "propertyForm_propertyDepartmentStoreOptions_Toys": "Іграшки",
  "propertyForm_propertyFoodAndDrinkOptions_bakery_and_baked_goods_store": "Магазин хлібобулочних виробів",
  "propertyForm_propertyFoodAndDrinkOptions_dairy_goods": "Молочні продукти",
  "propertyForm_propertyFoodAndDrinkOptions_food_and_drink": "Їжа та напої",
  "propertyForm_propertyFoodAndDrinkOptions_food_beverage_specialty_store": "Спеціалізований магазин продуктів харчування та напоїв",
  "propertyForm_propertyFoodAndDrinkOptions_grocery": "Продукти",
  "propertyForm_propertyFoodAndDrinkOptions_meat": "М'ясо",
  "propertyForm_propertyFoodAndDrinkOptions_specialty_food_store": "Спеціалізований магазин продуктів харчування",
  "propertyForm_propertyFoodAndDrinkOptions_Vegan": "Веган",
  "propertyForm_propertyFoodAndDrinkOptions_Vegetarian": "Вегетаріанське",
  "propertyForm_propertyFoodAndDrinkOptions_wine_and_liquor": "Вино та лікеро-горілчані вироби",
  "propertyForm_propertyDrugstoreOptions_drugstore": "Аптека",
  "propertyForm_propertyDrugstoreOptions_pharmacy": "Аптека",
  "propertyForm_propertyElectronicsOptions_computer_and_software": "Комп'ютери та програмне забезпечення",
  "propertyForm_propertyElectronicsOptions_consumer_electronics_store": "Магазин побутової електроніки",
  "propertyForm_propertyElectronicsOptions_electronics": "Електроніка",
  "propertyForm_propertyElectronicsOptions_entertainment_electronics": "Розважальна_електроніка",
  "propertyForm_propertyElectronicsOptions_mobile_retailer": "Мобільний ритейлер",
  "propertyForm_propertyElectronicsOptions_mobile_service_center": "Мобільний сервісний центр",
  "propertyForm_propertyMallOptions_shopping_gallery_mall": "Торгово-галерейний комплекс",
  "propertyForm_propertyMallOptions_shopping_mall": "Торговий центр",
  "propertyForm_standardTypeOptions_hotel_motel": "Готель/Мотель",
  "propertyForm_standardTypeOptions_shopping_mall": "Торговий центр",
  "propertyForm_standardTypeOptions_shop": "Магазин",
  "propertyForm_propertyHardwareOptions_floor_and_carpet": "Підлога та килимове покриття",
  "propertyForm_propertyHardwareOptions_furniture_store": "Меблевий магазин",
  "propertyForm_propertyHardwareOptions_garden_center": "Садовий центр",
  "propertyForm_propertyHardwareOptions_glass_and_window": "Скло та вікна",
  "propertyForm_propertyHardwareOptions_hardware_house_garden": "Садовий будиночок для господарських потреб",
  "propertyForm_propertyHardwareOptions_home_improvement_hardware_store": "Магазин будівельних матеріалів для дому",
  "propertyForm_propertyHardwareOptions_home_specialty_store": "Спеціалізований магазин для дому",
  "propertyForm_propertyHardwareOptions_lumber": "Пиломатеріали",
  "propertyForm_propertyHardwareOptions_major_appliance": "Основний прилад",
  "propertyForm_propertyHardwareOptions_paint_store": "Магазин фарб",
  "propertyForm_propertyHardwareOptions_power_equipment_dealer": "Дилер енергетичного обладнання",
  "propertyForm_propertyBookstoreOptions_bookstore": "Книгарня",
  "propertyForm_propertyClothingOptions_childrens_apparel": "Дитячий одяг",
  "propertyForm_propertyClothingOptions_clothing_and_accessories": "Одяг та аксесуари",
  "propertyForm_propertyClothingOptions_mens_apparel": "Чоловічий одяг",
  "propertyForm_propertyClothingOptions_shoes_footwear": "Магазин взуття",
  "propertyForm_propertyClothingOptions_specialty_clothing_store": "Магазин спеціалізованого одягу",
  "propertyForm_propertyClothingOptions_womens_apparel": "Жіночий одяг",
  "propertyForm_consumerGoodsOptions_adult_shop": "Магазин для дорослих",
  "propertyForm_consumerGoodsOptions_arts_and_crafts_supplies": "Витратні матеріали для декоративно-прикладного мистецтва",
  "propertyForm_consumerGoodsOptions_bicycle_and_bicycle_accessories_shop": "Магазин велосипедів та велоаксесуарів",
  "propertyForm_consumerGoodsOptions_camping_hiking_shop": "Магазин для кемпінгу та туризму",
  "propertyForm_consumerGoodsOptions_canoe_kayak_shop": "Магазин байдарок і каное",
  "propertyForm_consumerGoodsOptions_car_accessories": "Автомобільні аксесуари",
  "propertyForm_consumerGoodsOptions_consumer_goods": "Споживчі товари",
  "propertyForm_consumerGoodsOptions_cross_country_ski_shop": "Магазин бігових лиж",
  "propertyForm_consumerGoodsOptions_florist": "Флорист",
  "propertyForm_consumerGoodsOptions_general_merchandise": "Товари загального призначення",
  "propertyForm_consumerGoodsOptions_gift_antique_art": "Подарункове антикварне мистецтво",
  "propertyForm_consumerGoodsOptions_hobby_store": "Магазин хобі",
  "propertyForm_consumerGoodsOptions_hunting_fishing_shop": "Мисливський рибальський магазин",
  "propertyForm_consumerGoodsOptions_jeweler": "Ювелір",
  "propertyForm_consumerGoodsOptions_market": "Маркет",
  "propertyForm_consumerGoodsOptions_motorcycle_accessories": "Аксесуари для мотоциклів",
  "propertyForm_consumerGoodsOptions_non_store_retailers": "Немагазинна роздрібна торгівля",
  "propertyForm_consumerGoodsOptions_office_supply_store": "Магазин канцелярського приладдя",
  "propertyForm_consumerGoodsOptions_pawnshop": "Ломбард",
  "propertyForm_consumerGoodsOptions_pet_supply": "Зоотовари для домашніх тварин",
  "propertyForm_consumerGoodsOptions_record_cd_video": "Запис відео на компакт-диску",
  "propertyForm_consumerGoodsOptions_running_walking_shop": "Магазин бігової ходьби",
  "propertyForm_consumerGoodsOptions_skate_shop": "Магазин скейтів",
  "propertyForm_consumerGoodsOptions_ski_snowboard_shop": "Магазин лиж та сноубордів",
  "propertyForm_consumerGoodsOptions_specialty_store": "Спеціалізований магазин",
  "propertyForm_consumerGoodsOptions_sporting_goods_store": "Магазин спортивних товарів",
  "propertyForm_consumerGoodsOptions_surf_shop": "Магазин для серфінгістів",
  "propertyForm_consumerGoodsOptions_tack_shop": "Магазин фурнітури",
  "propertyForm_consumerGoodsOptions_toy_store": "Магазин іграшок",
  "propertyForm_consumerGoodsOptions_used_second_hand_merchandise_stores": "Магазини вживаних товарів секонд-хенд",
  "propertyForm_consumerGoodsOptions_variety_store": "Крамниця з різноманітними товарами",
  "propertyForm_consumerGoodsOptions_video_and_game_rental": "Прокат відео та ігор",
  "propertyForm_consumerGoodsOptions_warehouse_wholesale_store": "Склад оптового магазину",
  "propertyForm_hairAndBeautyOptions_barber": "Барбершоп",
  "propertyForm_hairAndBeautyOptions_hair_and_beauty": "Волосся та краса",
  "propertyForm_hairAndBeautyOptions_hair_salon": "Перукарня",
  "propertyForm_hairAndBeautyOptions_nail_salon": "Манікюрний салон",
  "propertyForm_hairAndBeautyOptions_make_up_salon": "Салон макіяжу",
  "propertyForm_mallTopCategoryOptions_mall_shopping_complex": "Торговий Молл комплекс",
  "propertyForm_accomodationsCategoryOptions_hotel_motel": "Готель/Мотель",
  "propertyForm_shopCategoryOptions_convenience_store": "Магазин товарів повсякденного попиту",
  "propertyForm_shopCategoryOptions_department_store": "Універмаг",
  "propertyForm_shopCategoryOptions_food_and_drink": "Їжа та напої",
  "propertyForm_shopCategoryOptions_drugstore_or_pharmacy": "Аптека або аптечний пункт",
  "propertyForm_shopCategoryOptions_electronics": "Електроніка",
  "propertyForm_shopCategoryOptions_hardware_house_garden": "Садовий будиночок для господарських потреб",
  "propertyForm_shopCategoryOptions_bookstore": "Книгарня",
  "propertyForm_shopCategoryOptions_clothing_and_accessories": "Одяг та аксесуари",
  "propertyForm_shopCategoryOptions_consumer_goods": "Споживчі товари",
  "propertyForm_shopCategoryOptions_hair_and_beauty": "Волосся та краса",
  "facilitiesForm_standardTypeOptions_hotel_motel": "Готель/Мотель",
  "facilitiesForm_standardTypeOptions_office": "Офіс",
  "facilitiesForm_standardTypeOptions_shopping_mall": "Торговий центр",
  "facilitiesForm_standardTypeOptions_shop": "Магазин",
  "facilitiesForm_selectFacilitiesForDataCollection": "2. Оберіть об'єкти для збору даних",
  "facilitiesForm_preselectedMandatoryItems": "Наступні попередньо вибрані елементи є обов'язковими для заповнення",
  "facilitiesForm_mandatoryFacilitiesFor": "Обов'язкові об'єкти для",
  "facilitiesForm_optionalFacilitiesFor": "Додаткові об'єкти для",
  "facilitiesForm_standard": "Стандарт",
  "facilitiesForm_preselectedOptionalItems": "Наступні пункти є необов'язковими",
  "facilitiesForm_faq_mandatoryFacilities": "Що таке обов'язкові об'єкти?",
  "facilitiesForm_faq_AnswerMandatoryFacilities": "Це стандартні об'єкти, які ми знаходимо на об'єктах вашого типу. Для того, щоб ретельно зібрати дані про доступність, ці об'єкти повинні бути оцінені. Біля входу в будівлю",
  "facilitiesForm_faq_optionalFacilities": "Що таке додаткові об'єкти?",
  "facilitiesForm_faq_AnswerOptionalFacilities": "Це неповний перелік об'єктів, які можуть існувати або не існувати у вашому об'єкті нерухомості, але які не обов'язково є стандартними об'єктами у подібних об'єктах. Наприклад, спа-центр у готелі або торговому центрі.",
  "unitForm_helperText_entrance_key": "Вхід",
  "unitForm_helperText_entrance_value": "тобто головний вхід або другорядні входи, наприклад, через ресторан або сад",
  "unitForm_helperText_lobby_key": "Вестибюль",
  "unitForm_helperText_lobby_value": "тобто головне фойє об'єкта нерухомості, включаючи лаунж або зону очікування",
  "unitForm_helperText_reception_key": "Стійка реєстрації/інформаційна стійка",
  "unitForm_helperText_reception_value": "наприклад, головна стійка реєстрації, стійка консьєржа, зона зберігання багажу або інформаційна стійка",
  "unitForm_helperText_facility_key": "Об'єкт",
  "unitForm_helperText_facility_value": "",
  "unitForm_helperText_parking_key": "Парковка та найближче оточення",
  "unitForm_helperText_parking_value": "тобто основна зона паркування та додаткові зовнішні зони, такі як сади, під'їзні шляхи, пішохідні доріжки",
  "unitForm_helperText_commonAreas_key": "Зони загального користування",
  "unitForm_helperText_commonAreas_value": "Спільні громадські зони готелю, такі як лобі-лаунж, коридори тощо.",
  "unitForm_helperText_conferenceRoom_key": "Конференц-зал / кімната для переговорів",
  "unitForm_helperText_conferenceRoom_value": "",
  "unitForm_helperText_auditorium_key": "Аудиторія",
  "unitForm_helperText_auditorium_value": "Простір у стилі театру, кінотеатру тощо.",
  "unitForm_helperText_diningArea_key": "Обідня зона",
  "unitForm_helperText_diningArea_value": "наприклад, головний ресторан, зона для сніданків \"шведський стіл\", лобі-бар / бістро",
  "unitForm_helperText_toiletRoom_key": "Туалет (загальний, спільний)",
  "unitForm_helperText_toiletRoom_value": "тобто спільний туалет / ванна кімната, доступний з лобі, ресторану або інших громадських місць",
  "unitForm_helperText_gym_key": "Тренажерний зал",
  "unitForm_helperText_gym_value": "",
  "unitForm_helperText_spa_key": "Спа",
  "unitForm_helperText_spa_value": "",
  "unitForm_helperText_hospitalityRoom_key": "Тип гостьової кімнати",
  "unitForm_helperText_hospitalityRoom_value": "тобто тип номера, наприклад, одномісний, двомісний, з обмеженими фізичними можливостями, сімейний і т.д.",
  "unitForm_quantityLabel": "Виберіть кількість",
  "unitForm_locationFaq": "Де вона знаходиться?",
  "unitForm_totalQuantity": "Загальна кількість",
  "unitForm_floorSelection": "Виберіть поверх",
  "unitForm_finishedCreation": "Ви закінчили створювати одиниці?",
  "unitForm_startClassifying": "Анкетування!",
  "unitForm_unitData2": "Приватний туалет",
  "unitForm_unitData3": "Власна ванна кімната",
  "unitForm_unitData4": "Власна кухня",
  "unitForm_unitTypeDetails": "3. Інформація про тип одиниці:",
  "unitForm_unitName": "Напишіть тут назву вашої одиниці",
  "unitForm_accessibleUnit": "Ця одиниця вважається доступною",
  "questionUnits_addNewUnit": "Додати нову одиницю",
  "questionUnits_savedInfo": "Ваша інформація збережена",
  "questionUnits_removedInfo": "Ваша інформація була видалена",
  "questionUnits_resources": "Ресурси",
  "questionUnits_uploadPictures": "Завантажити зображення",
  "questionUnits_explanation": "Деякі пояснення / деталі про цей розділ можна знайти тут",
  "questionUnits_uploadLabel": "ЗАВАНТАЖИТИ",
  "questionUnits_unitExtraInfo": "Додаткова інформація про блок",
  "questionUnits_unitExtraInfoPlaceholder1": "Тут ви можете вставити приватні коментарі до цього конкретного блоку",
  "questionUnits_unitExtraInfoPlaceholder2": "( наразі ви не маєте коментарів до цього блоку ) ",
  "questionUnits_beforeClassification": "Ви повинні додати об'єкти перед тим, як почати класифікувати",
  "questionUnits_editFacilities": "Редагувати об'єкти",
  "questionUnits_addNew": "Натисніть \"Додати нову\" або виберіть одиницю, щоб почати класифікацію",
  "questionUnits_faq1": "Інформація",
  "questionUnits_faq2": "Що таке обов'язкові об'єкти?",
  "questionUnits_faq2_1": "Це стандартні об'єкти, які ми знаходимо на об'єктах вашого типу. Для того, щоб ретельно зібрати дані про доступність, ці об'єкти повинні бути оцінені. Біля входу в будівлю",
  "questionUnits_faq3": "Що таке додаткові об'єкти?",
  "questionUnits_faq3_1": "Це неповний перелік об'єктів, які можуть існувати або не існувати у вашому об'єкті нерухомості, але які не обов'язково є стандартними об'єктами у подібних об'єктах. Наприклад, спа-центр у готелі або торговому центрі.",
  "FAR_SelectProperty": "Виберіть нерухомість",
  "FAR_DocumentPreview": "Попередній перегляд документа:",
  "FAR_DownloadPDF": "Завантажити PDF:",
  "FAR_Download": "Завантажити зараз!",
  "CLP_SelectProperty": "Виберіть нерухомість",
  "CLP_SelectPropertyForChecklist": "Виберіть нерухомість, щоб створити контрольний список",
  "CLP_AccessibilityChecklist": "Контрольний список доступності",
  "CLP_GeneratedOn": "Згенеровано на ",
  "CLP_GeneratedBy": "Згенеровано ",
  "CLP_LoadingDoc": "Завантаження документа...",
  "CLP_DownloadNow": "Завантажити зараз!",
  "A11yUnitsPageSubTitle": "Про що слід пам'ятати",
  "A11yUnitsPageDescription": "Ви можете асоціювати одиниці, схожі між собою, тільки якщо вони абсолютно однакові. В іншому випадку слід створити інший тип одиниці.",
  "routes_NewProperty": "Нова нерухомість",
  "routes_EditProperty": "Редагувати нерухомість",
  "routes_EditFacility": "Редагувати споруди",
  "routes_SelectFacilities": "Вибір об'єктів",
  "routes_CreateProperty": "Створити нерухомість",
  "routes_Classify": "Класифікація",
  "routes_Blank": "Пустий",
  "changePassword_success": "Успіх",
  "changePassword_successMessage": "Ваш пароль було оновлено",
  "changePassword_returnToLogin": "Повернутися до входу",
  "changePassword_resetPassword": "Скинути пароль",
  "changePassword_newPassword_label": "Новий пароль",
  "changePassword_confirmNewPassword_label": "Підтвердити новий пароль",
  "changePassword_newPasswordRequired_errorMessage": "Потрібен новий пароль",
  "changePassword_newPasswordMismatch_errorMessage": "Паролі повинні співпадати",
  "changePassword_newPassword_browserTab": "Змінити пароль",
  "DocumentationPage_pageTitle": "Сторінка документації",
  "DocumentationPage_tabtitle": "Документація",
  "DownloadsPage_pageTitle": "Сторінка завантажень",
  "LanguagesDropdown_English": "Англійська",
  "LanguagesDropdown_French": "Французька",
  "LanguagesDropdown_German": "Німецька",
  "LanguagesDropdown_Dutch": "Голландська",
  "LocationAutocomplete_searchPlaceholder": "Пошук місць ...",
  "LocationAutocomplete_validAddress": "Будь ласка, вкажіть номер будинку та вулицю",
  "LocationAutocomplete_addressEmpty": "Адреса не може бути пустою",
  "page404_PageNotFound": "Сторінку не знайдено.",
  "page404_PageNotFound_explanation": "Сторінка, яку ви шукаєте, могла бути видалена.",
  "page404_PageNotFound_returnHome_button": "Повернутися на сайт",
  "page500_InternalError": "Внутрішня помилка сервера.",
  "page500_InternalError_explanation": "Сервер зіткнувся з чимось несподіваним, що не дозволило йому завершити запит.",
  "propertyListPage_NotClassified": "Не класифіковано",
  "propertyListIconName_allergy_food_class": "Клас їжі для алергіків",
  "propertyListIconName_allergy_room_class": "Клас кімнати для алергіків",
  "propertyListIconName_mobility_class": "Клас мобільності",
  "propertyListIconName_hearing_class": "Клас слуху",
  "propertyListIconName_cognitive_class": "Когнітивний клас",
  "propertyListIconName_visual_class": "Візуальний клас",
  "propertyForm_AllStepsCompleted": "Всі кроки виконано",
  "propertyForm_propertyReady": "Ваша нерухомість готова!",
  "propertyForm_propertyReady_description": "Ви завершили крок заповнення інформації про нерухомість. Ви можете відредагувати цю інформацію, натиснувши на посилання Список властивостей у верхній лівій панелі.",
  "propertyForm_startClassifying": "ПОЧНІТЬ КЛАСИФІКУВАТИ",
  "propertyForm_propertyStepper_step1": "Додати інформацію про власність",
  "propertyForm_propertyStepper_step2": "Виберіть об'єкти",
  "propertyForm_propertyStepper_step3": "Додати інформацію про одиницю",
  "settingsForms_CompanyInformation_SelectOptions_Service": "Сервіс",
  "settingsForms_CompanyInformation_SelectOptions_Merchandising": "Мерчандайзинг",
  "settingsForms_CompanyInformation_SelectOptions_Manufacturing": "Виробництво",
  "settingsForms_CompanyInformation_SelectOptions_Other": "Інше",
  "settingsForms_ImageCantBeChanged": "Це зображення не можна змінити",
  "settingsForms_RegNumber_label": "Реєстраційний номер",
  "settingsForms_InvoiceStatus_label": "Статус фактури",
  "settingsForms_CompanyName_label": "Назва компанії",
  "settingsForms_CompanyType_label": "Тип компанії",
  "settingsForms_CompanySize_label": "Розмір компанії",
  "settingsForms_CompanyAddress_label": "Адреса компанії",
  "settingsForms_ContractDate_label": "Дата підписання договору",
  "settingsForms_SubscriptionPeriod_label": "Період підписки",
  "settingsForms_Employees_label": "Працівники",
  "settingsForms_UserInformation_positionOptions_owner": "Власник",
  "settingsForms_UserInformation_positionOptions_executive": "Директор",
  "settingsForms_UserInformation_positionOptions_manager": "Менеджер",
  "settingsForms_UserInformation_positionOptions_operations_and_production": "Операції та виробництво",
  "settingsForms_UserInformation_positionOptions_other": "Інше",
  "settingsForms_UserInformation_departmentOptions_it": "IT",
  "settingsForms_UserInformation_departmentOptions_marketing": "Маркетинг",
  "settingsForms_UserInformation_departmentOptions_finance": "Фінанси",
  "settingsForms_UserInformation_departmentOptions_human_resources": "Кадрові ресурси",
  "settingsForms_UserInformation_departmentOptions_sales": "Продажі",
  "settingsForms_UserInformation_departmentOptions_operations": "Операції",
  "settingsForms_UserInformation_departmentOptions_other": "Інше",
  "settingsForms_UserInformation_title": "Інформація про користувача",
  "settingsForms_UserInformation_UploadPicture": "Завантажити зображення",
  "settingsForms_UserInformation_formatRestriction": "Використовуйте зображення розміром не менше 128x128 у форматі .jpg",
  "settingsForms_UserInformation_surname": "Прізвище",
  "settingsForms_UserInformation_position": "Посада",
  "settingsForms_UserInformation_department": "Департамент",
  "settingsPage_pageTitle": "Сторінка налаштувань",
  "settingsPage_breadcrumbs_dashboard": "Інформаційна панель",
  "settingsPage_breadcrumbs_settings": "Налаштування",
  "signinForm_explanation": "Увійдіть у свій обліковий запис, щоб продовжити",
  "signinForm_validEmail_error": "Повинна бути дійсна адреса електронної пошти",
  "signinForm_emailRequired": "Потрібна електронна пошта",
  "signinForm_generalError": "Щось пішло не так",
  "signinForm_passwordRequired": "Потрібен пароль",
  "signinForm_emailLabel_textfield": "Електронна пошта",
  "signinForm_passwordLabel_textfield": "Пароль",
  "signinForm_remberMeCheckbox_textfield": "Запам'ятайте мене",
  "signinForm_signIn_button": "Увійти в систему",
  "signinForm_forgotPassword_button": "Забули пароль",
  "signupForm_signUp_button": "Зареєструватися",
  "signupForm_signUp_title": "Почнімо",
  "signupForm_signUp_subTitle": "Почніть створювати найкращий користувацький досвід для своїх клієнтів",
  "signupForm_signUp_nameRequired": "Ім'я обов'язкове",
  "signupForm_signUp_minCharacters_errorMessage": "Повинно бути не менше 12 символів",
  "signupForm_signUp_required_errorMessage": "Обов'язково",
  "signupForm_signUp_nameLabel": "Назва",
  "signupForm_signUp_companyLabel": "Компанія",
  "signupForm_signUp_emailAddressLabel": "Електронна пошта",
  "signupForm_signUp_passwordLabel": "Пароль",
  "signupForm_signUp_confirmPasswordLabel": "Підтвердити пароль",
  "statsPage_pageTitle": "Сторінка статистики",
  "statsPage_cardContent": "Ця сторінка буде доступна в наступних версіях Системи управління доступом.",
  "resetPassword_inbox": "Перевірте свою пошту",
  "resetPassword_explanation_1": "Ми надіслали електронного листа на адресу",
  "resetPassword_explanation_2": "з інструкціями щодо відновлення паролю",
  "resetPassword_title": "Скинути пароль",
  "resetPassword_subTitle": "Введіть електронну адресу, щоб скинути пароль",
  "unitForm_title": "Композитні одиниці",
  "unitForm_floorTitle": "Поверх",
  "unitImagesDialog_labelMANDATORY": "ОБОВ'ЯЗКОВО",
  "unitImagesDialog_labelOPTIONAL": "НЕОБОВ'ЯЗКОВО",
  "unitImagesDialog_labelPICTURES": "КАРТИНКИ",
  "unitImagesDialog_dropzone": "Перемістіть фото сюди або виберіть файл",
  "userDropdown_profile": "Профіль",
  "userDropdown_signout": "Вийди з системи",
  "questionUnits_uploadPictures_uploadError": "Виникла помилка під час завантаження зображень",
  "questionUnits_uploadSuccess": "Ваші дані успішно відправлені",
  "questionUnits_unitExtraInfoLabel": "Додаткова інформація",
  "questionUnits_unitExtraInfoDelete_button": "Видалити",
  "questionUnits_unitExtraInfoSave_button": "Зберегти",
  "QuestionnaireCompletionCard_title": "Заповнення стандартів",
  "QuestionnaireCompletionCard_disableMessage": "У вас поки що немає ніякої класифікації.",
  "QuestionnaireCompletionCard_ParkingCard": "Парковка",
  "QuestionnaireCompletionCard_EntranceCard": "Вхід",
  "QuestionnaireCompletionCard_ToiletCard": "Туалет",
  "QuestionnaireCompletionCard_RoomsCard": "Кімнати",
  "QuestionnaireCompletionCard_LiftAndElevatorsCard": "Ліфт і підйомники",
  "QuestionnaireCompletionCard_LobbyAndReceptionCard": "Лобі та рецепція",
  "FAR_Report": "Звіт про доступність",
  "FAR_TableUnitName": "Назва одиниці",
  "FAR_TableDescription": "Опис",
  "CLP_PleaseSelectProperty": "Будь ласка, виберіть об'єкт",
  "CLP_BrowserTabTitle": "Повний звіт про доступність",
  "CLP_UnitMandatoryLabel": "Обов'язкове",
  "CLP_UnitDoneLabel": "ГОТОВО",
  "propertyPage_Controllers_SearchDoc": "Пошук документації",
  "generalWords_Yes": "Так",
  "generalWords_No": "Ні",
  "generalWords_Next": "Далі",
  "generalWords_Close": "Закрити",
  "generalWords_Reset": "Обнулити",
  "generalWords_Back": "Назад",
  "generalWords_Finish": "Завершити",
  "generalWords_NextStep": "Наступний крок",
  "generalWords_Edit": "Редагувати",
  "generalWords_Download": "Завантажити",
  "generalWords_Delete": "Видалити",
  "generalWords_SaveChanges": "Зберегти зміни",
  "generalWords_Selected": "вибраний",
  "generalWords_Required": "Обов'язково",
  "customerSupportPage_title": "Сторінка підтримки клієнтів",
  "customerSupportPage_emailLabel": "Зверніться зі службою підтримки за адресою:",
  "unitForm_helperText_entrance": "тобто головний вхід або другорядні входи, наприклад, через ресторан або сад.",
  "unitForm_helperText_lobby": "Тобто головне фойє об'єкта нерухомості, включаючи лаунж або зону очікування.",
  "unitForm_helperText_reception": "наприклад, головна стійка реєстрації, стійка консьєржа, зона зберігання багажу або інформаційна стійка.",
  "unitForm_helperText_facility": "Тобто назва об'єкта або майна.",
  "unitForm_helperText_parking": "тобто основна зона паркування та додаткові зовнішні зони, такі як сади, під'їзні шляхи, пішохідні доріжки.",
  "unitForm_helperText_conferenceRoom": "Конференц-зал - це велика кімната, в якій можуть провести конференцію кілька людей.",
  "unitForm_helperText_auditorium": "Простір у стилі театру, кінотеатру тощо.",
  "unitForm_helperText_diningArea": "наприклад, головний ресторан, зона для сніданків \"шведський стіл\", лобі-бар / бістро.",
  "unitForm_helperText_toiletRoom": "тобто спільний туалет / ванна кімната, доступний з лобі, ресторану або інших громадських місць.",
  "unitForm_helperText_gym": "Фізичні вправи та активності, що виконуються в приміщенні, часто з використанням обладнання.",
  "unitForm_helperText_spa": "Місце, де можна розслабитися в сауні, басейні та джакузі.",
  "unitForm_helperText_hospitalityRoom": "тобто тип номера, наприклад, одномісний, двомісний, з обмеженими фізичними можливостями, сімейний тощо.",
  "unitForm_helperText_shopping_aisle": "тобто прохід між полицями.",
  "unitForm_helperText_counter": "Рівна поверхня (наприклад, стіл, полиця або вітрина), на якій здійснюються транзакції.",
  "unitForm_helperText_checkout_pay": "Наприклад, Каса, Самообслуговування, Каса зі скануванням.",
  "unitForm_helperText_fitting_room": "Кімната в магазині, в якій покупці можуть приміряти одяг, щоб перевірити, чи підходить він їм, перш ніж купувати його.",
  "unitForm_helperText_manned_kiosk": "Термінал для обміну або погашення готівки, який дозволяє здійснювати готівкові та безготівкові операції з касиром.",
  "unitForm_helperText_floor": "Тобто доступність на різних рівнях, наприклад, ліфт на 1 поверсі, зелений ліфт на вході 2.",
  "unitForm_helperText_playground": "Територія, на якій діти граються. Зазвичай вони мають обладнання, таке як гірки, гойдалки та гойдалки, на яких діти можуть гратися.",
  "unitForm_helperText_garden": "Місце, зазвичай на відкритому повітрі, відведене для вирощування, демонстрації та насолоди рослинами та іншими формами природи.",
  "unitForm_helperText_bathroom_common": "Приміщення з ванною або душем, зазвичай з раковиною та туалетом.",
  "unitForm_helperText_bathroom__private": "Окрема кімната з ванною або душем, зазвичай з раковиною та туалетом.",
  "unitForm_helperText_quiet_room": "Тиха кімната або безшумна кімната - це кімната, побудована з урахуванням тиші шляхом екранування шуму від навколишнього середовища або в напрямку до нього.",
  "unitForm_helperText_kitchen_common": "Громадське приміщення, де можна готувати їжу.",
  "unitForm_helperText_toilet_room__private": "тобто приватний туалет, доступний з лобі, ресторану або інших громадських місць.",
  "unitForm_helperText_kitchen__private": "Окрема кімната, де можна готувати їжу.",
  "unitForm_helperText_conferenceRoom_": "",
  "routes_Services": "Послуги",
  "routes_Help": "Допомога",
  "routes_Clp": "Контрольний список",
  "routes_Far": "Звіт про доступність",
  "FAR_WhatIsItTitle": "Що таке звіт про доступність?",
  "FAR_WhatIsItDescription": "Звіт про доступність - це звіт, який ми створюємо для вас залежно від того, наскільки доступним є ваш об'єкт нерухомості. Нижче ви можете вибрати об'єкт нерухомості та завантажити його звіт у форматі PDF.",
  "FAR_MoreInfo": "Для отримання додаткової інформації про Звіт про доступність, будь ласка",
  "FAR_SelectPropertyForChecklist": "Виберіть об'єкт для створення звіту",
  "CLP_noChecklistFound": "Ми не змогли знайти список для цього об'єкта",
  "CLP_WhatIsItTitle": "Що таке контрольний список?",
  "CLP_WhatIsItDescription": "Контрольний список - це перелік, складений на основі інформації з інвентаризації Системи доступності. Він показує сфери, які потребують покращення, на основі ваших даних, внесених до системи. Доступний попередній перегляд документа, який можна завантажити або роздрукувати.",
  "CLP_MoreInfo": "Для отримання додаткової інформації про Контрольний список, будь ласка",
  "CLP_FAR_ConsultTheDocumentation": "ознайомтесь з документацією",
  "LanguagesDropdown_Swedish": "Шведська",
  "LanguagesDropdown_Danish": "Данська",
  "gettingStartedCard_step1_link": "Прочитати",
  "gettingStartedCard_step2_link": "Завантажити",
  "gettingStartedCard_step3_link": "Подивитися",
  "contactForm_category": "Категорія",
  "contactForm_title": "Зв'яжіться з нами",
  "contactForm_chooseImg": "Виберіть зображення",
  "contactForm_submitBtn": "Надіслати запит",
  "contactForm_attachBtnLabel": "Якщо можливо, будь ласка, додайте скріншот.",
  "contactForm_messageLabel": "Будь ласка, опишіть ваш запит тут.",
  "contactForm_messageEmptyError": "Будь ласка, додайте повідомлення",
  "contactForm_categoryOptions_ServiceInquiry": "Сервісні питання",
  "contactForm_categoryOptions_TechnicalIssues": "Технічні питання",
  "contactForm_categoryOptions_OtherInquires": "Інші запити",
  "contactForm_subtitle1": "Якщо ви не можете знайти відповідь, яку шукаєте, ми тут, щоб простягнути руку допомоги.",
  "contactForm_subtitle2": "Будь ласка, напишіть нам! Ми зв'яжемося з вами якнайшвидше.",
  "FAR_noDataAvalible_1": "Звіт про доступність ще не може бути створений для цього об'єкта. Будь ласка, спочатку заповніть",
  "FAR_noDataAvalible_2": "для",
  "FAR_noDataAvalible_3": "першим.",
  "CLP_Updating": "Оновлення...",
  "CLP_AreYouSure": "Ви впевнені?",
  "CLP_UpdateMessage": "Якщо ви це зробите, пункт зникне з контрольного списку, а стандарт буде автоматично оновлено відповідно до змін.",
  "CLP_Cancel": "СКАСУВАТИ",
  "CLP_YesUpdate": "ТАК, ОНОВИТИ",
  "CLP_WhatIsAChecklist": "Що таке контрольний список?",
  "CLP_Name": "Назва",
  "CLP_pdfDisclaimer": "Примітка: Після внесення змін не забудьте оновити дані про доступність у стандартному розділі.",
  "CLP_FAR_noAccessibilityDataAvailable1": "Ми не маємо жодних даних про доступність. ",
  "CLP_noChecklist1": "Контрольний список ще не може бути створений для цієї властивості. Дайте відповіді на запитання у ",
  "CLP_noChecklist2": "стандартній секції ",
  "CLP_noChecklist3": "для",
  "CLP_noChecklist4": "спершу.",
  "CLP_FAR_noAccessibilityDataAvailable2": "Створіть властивість",
  "CLP_FAR_noAccessibilityDataAvailable3": " і спочатку дайте відповіді на запитання в стандартному розділі.",
  "statsPage_subscriptionExpiring": "Підписка закінчується через",
  "statsPage_days": "днів",
  "statsPage_contactCustomerSupport": "Звернутися до служби підтримки",
  "statsPage_companyInformation": "Інформація про компанію",
  "statsPage_numberOfPhotosUploaded": "Кількість завантажених фотографій",
  "statsPage_photos": "зображення",
  "statsPage_totalAmountProperties": "Загальна кількість об'єктів нерухомості",
  "statsPage_amountCompleted": "Кількість завершених дій",
  "statsPage_actionsPerVisitor": "Дії на одного відвідувача на віджеті",
  "statsPage_yourItems": "Ваші продукти",
  "statsPage_name": "Назва",
  "statsPage_sku": "Номер артикулу",
  "statsPage_quantity": "Кількість",
  "statsPage_numberOfUnits": "Кількість одиниць",
  "statsPage_accessible": "Доступний",
  "statsPage_notAccessible": "Недоступний",
  "statsPage_unit": "Одиниця",
  "statsPage_amount": "Кількість",
  "statsPage_incomplete": "Незавершений",
  "statsPage_completed": "Завершено",
  "statsPage_notCompleted": "Не завершено",
  "statsPage_mobility": "Мобільність",
  "statsPage_cognitive": "Когнітивний",
  "statsPage_hearing": "Слухання",
  "statsPage_visual": "Візуальна",
  "statsPage_allergy": "Алергія",
  "statsPage_class": "Клас",
  "statsPage_totalAccessibilityDatapoints": "Загальна кількість одиниць доступності",
  "statsPage_visitorsThatOpened": "Відвідувачі, які відкрили віджет",
  "statsPage_visitorsInteraction": "Загальна кількість дій на віджеті",
  "statsPage_action": "Дії",
  "statsPage_clicks": "Кліки",
  "statsPage_noDataAvailable_topText": "Дані відсутні",
  "statsPage_noDataAvailable_bottomText": "На даний момент",
  "statsPage_company_address": "Адреса",
  "statsPage_company_city": "Місто",
  "statsPage_company_country": "Країна",
  "statsPage_company_name": "Назва",
  "statsPage_company_type": "Тип",
  "statsPage_company_registration_number": "Реєстраційний номер",
  "statsPage_company_logo": "Логотип",
  "statsPage_company_employees": "Працівники",
  "statsPage_company_empty_fields": "Порожні поля",
  "settingsPage_alertMsgImageUpload": "Натисніть зберегти, щоб оновити зображення вашого профілю",
  "settingsPage_alertMsgCompanyInformation_1": "Контакти",
  "settingsPage_alertMsgCompanyInformation_2": "Підтримка клієнтів",
  "settingsPage_alertMsgCompanyInformation_3": "якщо вам потрібно внести зміни до Інформації про компанію.",
  "documentationPage_downloadDocument": "Завантажити документ",
  "documentationPage_loadingDocument": "Завантаження документа",
  "CLP_Status": "Статус",
  "CLP_lastUpdate": "Останнє оновлення",
  "CLP_completed": "завершений",
  "CLP_incomplete": "незавершений",
  "LanguagesDropdown_Languages": "Мови",
  "login_welcome_message": "Ласкаво просимо до Системи управління доступом 👋",
  "CLP_Checklist_is_generated_based": "Контрольний список створюється на основі даних про доступність, які ми збираємо з вашого об'єкта нерухомості. Він показує сфери, які потребують покращення, і як тільки ви відмічаєте пункт, відповідь автоматично оновлюється в системі, а ваші дані про доступність будуть змінені. Документ можна завантажити для зовнішнього використання. Для отримання додаткової інформації",
  "CLP_Go_to_checklist": "Перейти до контрольного списку",
  "CLP_Updated_date": "Дата оновлення",
  "CLP_The_purpose_of_Handiscover_1": "Мета інвентаризації та контрольного списку Handiscover - допомогти вам у покращенні вашої доступності. Список, що додається, складається з декількох пунктів. З точки зору того, що має бути адаптовано до доступності, є пункти, які є обов'язковими. Крім того, ми визначили пункти, які ми рекомендуємо, наприклад, будувати нові чи реконструювати старі об'єкти.",
  "CLP_List_points": "Перелік пунктів",
  "CLP_Priority": "Пріоритет",
  "CLP_User": "Користувач",
  "CLP_Mandatory": "Обов'язково",
  "CLP_Need_help": "Потрібна допомога? Зверніться до нашої команди",
  "CLP_Handiscovers_suggestions": "Пропозиції Handiscover",
  "propertyForm_nextStep_tooltip": "Спочатку заповніть всі обов'язкові поля",
  "statsPage_See_photos": "See photos",
  "statsPage_Your_subscription": "Ваша підписка",
  "statsPage_Filter_data_from": "Відфільтрувати дані з",
  "statsPage_Filter_data_to": "Відфільтрувати дані по",
  "statsPage_to": "до",
  "statsPage_Reload": "Перезавантажити",
  "statsPage_Business_Metrics": "Бізнес показники",
  "statsPage_Service_Metrics": "Сервісні показники",
  "statsPage_Statistics_page": "Сторінка статистики",
  "imagesPage_Pictures_List": "Список зображень",
  "imagesPage_Search_by_name": "Пошук за назвою",
  "imagesPage_No_pictures_available": "Зображень немає",
  "imagesPage_Name": "Назва",
  "imagesPage_Display_in_widget": "Відображення у віджеті",
  "imagesPage_Type": "Тип",
  "imagesPage_Update_date": "Дата оновлення",
  "imagesPage_Mandatory": "Обов'язковий",
  "imagesPage_Are_your_sure": "Ви впевнені?",
  "imagesPage_Delete": "Видалити",
  "imagesPage_Yes": "Так",
  "imagesPage_Cancel": "Скасувати",
  "imagesPage_Open_image": "Відкрити зображення",
  "imagesPage_Edit": "Редагувати",
  "imagesPage_Delete_image": "Видалити зображення",
  "CLP_The_purpose_of_Handiscover_2": "Ми також включили пункти, які \"легко\" виправити, але які можуть бути важливими з точки зору доступності.",
  "a11yUnits_The_title_has_been_translated": "Назву було перекладено",
  "statsPage_Statistics": "Статистика",
  "customerSupportPage_thankYou": "Дякуємо!",
  "customerSupportPage_requestSuccessfully": "Ваш запит успішно відправлено. Наша служба підтримки клієнтів опрацює ваш запит і зв'яжеться з вами якнайшвидше.",
  "customerSupportPage_warning": "Попередження",
  "customerSupportPage_error": "Помилка",
  "propertyListPage_showAll": "Показати всі",
  "propertyListPage_completed": "Завершені",
  "propertyListPage_incomplete": "Незавершені",
  "dashboard": "Інформаційна панель",
  "widget": "Віджет",
  "property_type": "Тип нерухомості",
  "category": "Категорія",
  "edit_widget": "Редагувати віджет",
  "created": "Створений",
  "published": "Опублікований",
  "unpublished": "Неопублікований",
  "widget_info": "Віджет доступності відображає детальні дані про доступність, попередньо зареєстровані в Системі управління доступністю. Цей віджет дозволяє створити кращі умови для відвідувачів, щоб вони могли заздалегідь планувати своє перебування, бачачи доступність об'єкта. Віджет доступності є інтерактивним, оскільки всі дані, що оновлюються в системі, відтворюються у віджеті.",
  "view_live_widget": "Перегляд віджету",
  "no_widget_data_message": "У нас немає даних про віджет. Будь ласка, зверніться до нашої служби підтримки.",
  "image_list": "Список зображень",
  "language_setting": "Налаштування мови",
  "history": "Історія",
  "select_accessibility_unit": "Виберіть одиницю доступності",
  "add_new_image": "Додати нове зображення",
  "order": "Порядок",
  "image": "Зображення",
  "description": "Опис",
  "accessibility_unit": "Одиниця доступності",
  "accessibility": "",
  "displayed_in_widget": "",
  "current_image": "",
  "upload_new_picture": "Завантажити нове зображення",
  "image_description": "Опис зображення",
  "image_order": "Порядок зображень",
  "back_to_list": "Повернутися до списку",
  "no_picture": "Зображення немає",
  "please_write_the_text_in": "Будь ласка, введіть текст",
  "yes_delete": "ТАК, ВИДАЛИТИ",
  "delete_warning_text": "Якщо ви це зробите, елемент зникне з віджета, а стандарт буде автоматично оновлено відповідно до змін.",
  "select_language_the_widget_provide": "Виберіть мову віджету",
  "changed_by": "Змінено",
  "activity": "Діяльність",
  "showing": "Показати",
  "of": "",
  "items": "елементи",
  "questionnaire": "Анкета",
  "we_are_showing_followings": "Ми відображаємо наступну інформацію у вашому віджеті",
  "we_are_recommended_to_state": "Ми рекомендуємо вказати корисну інформацію у віджеті для відвідувачів вашої власності. Якщо ви хочете внести зміни, будь ласка, зв'яжіться з нашою службою підтримки.",
  "select_what_you_want_to_show": "Виберіть, що ви хочете показати у віджеті",
  "practical_information": "Практична інформація",
  "you_can_add_maximum": "Ви можете додати максимум 3 речення",
  "for_the_best_experiences_in_widget": "Для кращого досвіду використання віджету, ми допоможемо вам, якщо ви побажаєте додати більше інформації",
  "if_you_do_this_the_item_will_disappear": "Якщо ви це зробите, елемент зникне з віджета",
  "you_can_write_free_texts": "Ви можете писати вільні тексти, щоб додати їх до загальної інформації, якщо це необхідно. Максимум 40 символів",
  "write_a_new_information": "Напишіть нову інформацію",
  "you_can_drag_and_drop_the_block": "Ви можете перетягнути блок, щоб змінити порядок. Будь ласка, встановіть прапорець для відображення у віджеті.",
  "you_can_freely_change_the_images_ordering": "Ви можете вільно змінювати порядок зображень за допомогою перетягування.",
  "preview": "Попередній перегляд",
  "add_point_on_map": "Додати точку на карту",
  "LanguagesDropdown_Spanish": "Іспанська",
  "LanguagesDropdown_Norwegian": "Норвезька",
  "LanguagesDropdown_Portuguese": "Португальська",
  "LanguagesDropdown_Ukrainian": "Українська",
  "main_unit_image": "Зображення основного блоку",
  "item_pictures": "Зображення елементів",
  "please_choose_a_main_unit_image": "Будь ласка, виберіть зображення головного блоку",
  "please_choose_a_item_picture": "Будь ласка, оберіть зображення елемента",
  "button_settings_updated": "Налаштування кнопок успішно оновлено",
  "button_settings_created": "Налаштування кнопки успішно створено",
  "button_settings": "Налаштування кнопок",
  "webmaster_instruction": "Інструкція для веб-майстрів",
  "contract_has_expired": "Термін дії вашого контракту закінчився. Віджет призупинено. Зверніться до служби підтримки",
  "webmaster_instructions_are_not_available": "Інструкції для веб-майстрів наразі недоступні. Зверніться до служби підтримки",
  "create_api_key": "Створіть ключ API для цієї компанії",
  "standard_instruction": "Стандартна інструкція",
  "google_tag_manager_instruction": "Інструкція Google Tag Manager"
}